import { createContext } from 'react';

// @ts-ignore
export default createContext();



// WEBPACK FOOTER //
// ./src/ModuleContext.ts